// auto-generated by Typewriter template _enums.tst from PortCall.Pilots.EndPoints\Api\PilotJobOrderChange\ApiPilotJobOrderChange.cs
export enum PilotJobOrderChangeType { 
    Creation = 1,
    StartEstimated = 2,
    EndEstimated = 3,
    StartActual = 4,
    EndActual = 5,
    StartTimeConfirmed = 6,
    DeepDraftConfirmed = 7,
    PilotAssignment = 8,
    PilotConfirmed = 9,
    AirDraft = 10,
    DeepDraft = 11,
    Remarks = 12,
    TugCompany = 13,
    LineHandlingCompany = 14,
    LaborStartTime = 15,
    BowThrusterOperational = 16,
    CancelledDate_DEPRECATED_20180517 = 17
}

export const PilotJobOrderChangeTypeDisplayName : { [val : number] : string } = { 
    1: 'Creation',
    2: 'StartEstimated',
    3: 'EndEstimated',
    4: 'StartActual',
    5: 'EndActual',
    6: 'StartTimeConfirmed',
    7: 'DeepDraftConfirmed',
    8: 'PilotAssignment',
    9: 'PilotConfirmed',
    10: 'AirDraft',
    11: 'DeepDraft',
    12: 'Remarks',
    13: 'TugCompany',
    14: 'LineHandlingCompany',
    15: 'LaborStartTime',
    16: 'BowThrusterOperational',
    17: 'CancelledDate_DEPRECATED_20180517'
}

export const PilotJobOrderChangeTypes : { Id : PilotJobOrderChangeType, Name : string }[] = [ 
    { Id: PilotJobOrderChangeType.Creation, Name: 'Creation' },
    { Id: PilotJobOrderChangeType.StartEstimated, Name: 'StartEstimated' },
    { Id: PilotJobOrderChangeType.EndEstimated, Name: 'EndEstimated' },
    { Id: PilotJobOrderChangeType.StartActual, Name: 'StartActual' },
    { Id: PilotJobOrderChangeType.EndActual, Name: 'EndActual' },
    { Id: PilotJobOrderChangeType.StartTimeConfirmed, Name: 'StartTimeConfirmed' },
    { Id: PilotJobOrderChangeType.DeepDraftConfirmed, Name: 'DeepDraftConfirmed' },
    { Id: PilotJobOrderChangeType.PilotAssignment, Name: 'PilotAssignment' },
    { Id: PilotJobOrderChangeType.PilotConfirmed, Name: 'PilotConfirmed' },
    { Id: PilotJobOrderChangeType.AirDraft, Name: 'AirDraft' },
    { Id: PilotJobOrderChangeType.DeepDraft, Name: 'DeepDraft' },
    { Id: PilotJobOrderChangeType.Remarks, Name: 'Remarks' },
    { Id: PilotJobOrderChangeType.TugCompany, Name: 'TugCompany' },
    { Id: PilotJobOrderChangeType.LineHandlingCompany, Name: 'LineHandlingCompany' },
    { Id: PilotJobOrderChangeType.LaborStartTime, Name: 'LaborStartTime' },
    { Id: PilotJobOrderChangeType.BowThrusterOperational, Name: 'BowThrusterOperational' },
    { Id: PilotJobOrderChangeType.CancelledDate_DEPRECATED_20180517, Name: 'CancelledDate_DEPRECATED_20180517' }
]



// WEBPACK FOOTER //
// ./server/enums/PilotJobOrderChangeType.ts